import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import * as dashboardAPI from "../../api/dashboard";

const initialState = {
  data: null,
  loading: null,
};

const attendancePercentage = createAsyncThunk(
  "dashboard/attendancePercentage",
  async (_, { rejectWithValue }) => {
    try {
      const res = await dashboardAPI.attendancePercentage(_);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      rejectWithValue(error);
    }
  }
);

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    resetState: () => {
      return initialState;
    },
  },
  extraReducers: {
    [attendancePercentage.pending]: (state) => {
      state.loading = true;
    },
    [attendancePercentage.fulfilled]: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    [attendancePercentage.rejected]: (state) => {
      state.loading = false;
    },
  },
});

const { resetState } = dashboardSlice.actions;

export default dashboardSlice.reducer;

export { resetState, attendancePercentage };
